module.exports = __webpack_public_path__ + "img/match.134e3184.svg";